import { TRPCResponse } from '@/api/types';

type TParams = {
  url: string;
  body: string;
};

export const nativeFetch = async <TResponse>(
  params: TParams,
): Promise<TResponse | null> => {
  const { url, body } = params;
  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      cache: 'no-store',
    });

    // иногда ответ может быть пустым response.json() падает с ошибкой в таком случае
    const text = await res.text();

    if (!text) {
      return null;
    }

    let data: TRPCResponse<TResponse>;
    try {
      data = JSON.parse(text) as TRPCResponse<TResponse>;
    } catch (error) {
      console.error('nativeFetch: Failed to parse JSON. Raw body:', text);
      throw error;
    }

    if (data?.error) {
      const { code, message } = data.error;
      console.error(
        `nativeFetch: RPC error ${code}: ${message}`,
        data.error.data,
      );

      return null;
    }

    return data.result ?? null;
  } catch (error) {
    console.error(`nativeFetch: Network response was not ok: ${error}`);
    console.error(`nativeFetch: Request params: ${JSON.stringify(params)}`);
    if (error instanceof TypeError && error.cause) {
      console.error('nativeFetch cause:', error.cause);
    }

    return null;
  }
};
